<template>
  <div class="header">
    <a href="/"><span class="logo">Alphatenbyte</span></a>
    <div class="tool-bar">
      <el-menu
        class="menu-top"
        mode="horizontal"
        background-color="transparent"
        text-color="#fff"
        active-text-color="#ddd"
      >
        <el-menu-item index="Games"><a href="javascript:void(0);" @click="jump('/', 'Business')">业务内容</a></el-menu-item>
        <el-menu-item index="About"><a href="javascript:void(0);" @click="jump('/', 'About')">关于我们</a></el-menu-item>
        <el-menu-item index="Contact"><a href="javascript:void(0);" @click="jump('/', 'Contact')">联系方式</a></el-menu-item>
      </el-menu>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  methods: {
    jump(path, target) {
      const isNotInHome = this.$router.currentRoute.path !== path;
      if (isNotInHome) {
        this.$router.push({
          path,
          query: {t: target}
        })
      } else {
        location.href = `#${target}`;
      }
    },
  }
};
</script>
<style lang="scss" scoped>
$header-baisc-height: px2rem(60);
$header-element-height: px2rem(36);

.header {
  font-size: $font-size-basic;
  vertical-align: middle;
  line-height: $header-baisc-height;
  text-align: left;
  height: $header-baisc-height;
  // border-bottom: 1px solid $header-background-color;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2);
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  letter-spacing: 2px;
  color: $--color-primary;
  padding: 0 px2rem(30)!important;
  box-sizing: border-box;
  .logo {
    color: $--color-primary;
    font-family: Times New Roman, Futura, Helvetica, sans-serif;
    font-size: px2rem(20);
    font-weight: bolder;
    // font-style: italic;
  }
  .tool-bar {
    display: inline-block;
    position: absolute;
    right: 0;
    .menu-top {
      display: inline-block;
      margin-right: px2rem(24);
      border-bottom: 0;
      li {
        background-color: transparent!important;
        font-size: px2rem(13);
        color: $--color-primary !important;
        font-weight: bolder;
      }
      li:hover {
        background-color: transparent!important;
        color: #aaa!important;
      }
    }
  }

  .el-menu-item,
  .el-submenu__title {
    font-size: $font-size-basic;
    height: $header-baisc-height;
    line-height: $header-baisc-height;
  }
}
</style>
<style lang="scss">
.el-menu--horizontal > .el-submenu .el-submenu__title {
  font-size: $font-size-basic;
  height: $header-baisc-height;
  line-height: $header-baisc-height;
}
</style>